import { render, staticRenderFns } from "./ScreenTabFocusViewActions.vue?vue&type=template&id=231eee30&scoped=true&"
import script from "./ScreenTabFocusViewActions.vue?vue&type=script&lang=js&"
export * from "./ScreenTabFocusViewActions.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTabFocusViewActions.vue?vue&type=style&index=0&id=231eee30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231eee30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
